import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentcolor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.35 3.754a1.13 1.13 0 0 0-1.066-.753h-.754a1.13 1.13 0 0 0-1.13 1.13v2.262a1.13 1.13 0 0 0 1.13 1.13h.754c.493 0 .911-.314 1.067-.753m-12.7.754 1.388-4.166A.52.52 0 0 1 2.535 3c.225 0 .425.144.496.357l1.39 4.166M1.153 6.016h2.764M.651 9.001l2 2 2-2 2 2 2-2 2 2 2-2m-6.746-6v2.073h1.602a1.037 1.037 0 1 0 0-2.073zm-.003 2.073v2.45h1.79a1.225 1.225 0 0 0 0-2.45z"
    }, null, -1)
  ]))]))
}
export default { render: render }